import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateDisplayCancelBookingModal } from "../../../reducer/bookingReducer";
import { CircularProgress } from "@mui/material";
import useAllBookingFunction from "../../../hooks/bookingCustomHook/useAllBookingFunction";

const CancelBookingModal = () => {
  const { displayCancelBookingModal, bookingDetails } = useSelector((store) => store.booking);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const { handleBookingToBeCanceld } = useAllBookingFunction(setLoading);
  const handleClose = () => {
    dispatch(updateDisplayCancelBookingModal());
  };

  return (
    <Modal
      open={displayCancelBookingModal}
      centered
      title=""
      width={"auto"}
      styles={{ mask: { backdropFilter: "blur(2px)" } }}
      onCancel={handleClose}
      footer={
        <div className="w-[100%] flex gap-2 justify-center mt-5 font-outfit">
          <Button
            className="text-[16px] w-[11rem] h-[3rem]
            border-[#007FFF] text-[#007FFF] rounded-[0.5rem] font-[500] "
            onClick={handleClose}
          >
            NO
          </Button>

          <Button
            className="text-[#FFF] text-[16px] rounded-xl  bg-[#FC573B] 
            w-[11rem] h-[3rem] font-[600]"
            onClick={loading ? undefined : handleBookingToBeCanceld}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <div>YES</div>
            )}
          </Button>
        </div>
      }
    >
      <div className="font-nunito text-[1.125remrem] font-[600] text-[#4D4D4D]">
        Cancel Booking?
      </div>
      <div className="text-[#808080] font-nunito text-[0.875rem] font-[400]">
        By Clicking Yes your booking will be listed as cancelled. 
        {bookingDetails?.cmId && bookingDetails?.cmId?.length > 0
          ? <><br/> You will need to cancel this booking from <b> 
          {" " + bookingDetails?.source + " "}</b> as well.</>
          : ""}
      </div>
    </Modal>
  );
};

export default CancelBookingModal;
